<template>
  <div class="checks">
    <p :class="{ valid: new_password_mixed_case_valid }">
      <i class="material-icons yes">check</i>
      <i class="material-icons no">clear</i>
      Must contain mixed case letters
    </p>

    <p :class="{ valid: new_password_digit_valid }">
      <i class="material-icons yes">check</i>
      <i class="material-icons no">clear</i>
      Must contain at least one number
    </p>

    <p :class="{ valid: new_password_special_char_valid }">
      <i class="material-icons yes">check</i>
      <i class="material-icons no">clear</i>
      Must contain a special character (%$&@ etc)
    </p>

    <p :class="{ valid: new_password_8_chars_valid }">
      <i class="material-icons yes">check</i>
      <i class="material-icons no">clear</i>
      Must consist of at least 8 characters
    </p>
  </div>
</template>

<script>
export default {
  name: 'PasswordChecks',
  props: {
    password: String,
    onChange: Function,
  },
  computed: {
    new_password_mixed_case_valid() {
      if (!this.password) return false;
      const regex = new RegExp(/(?=.*[a-z])(?=.*[A-Z])/);
      return regex.test(this.password);
    },
    new_password_8_chars_valid() {
      if (!this.password) return false;
      return this.password.length >= 8;
    },
    new_password_digit_valid() {
      if (!this.password) return false;
      const regex = new RegExp(/(?=.*\d)/);
      return regex.test(this.password);
    },
    new_password_special_char_valid() {
      if (!this.password) return false;
      const regex = new RegExp(/(?=.*\W)/);
      return regex.test(this.password);
    },
    is_valid() {
      return (
        this.new_password_mixed_case_valid &&
        this.new_password_8_chars_valid &&
        this.new_password_digit_valid &&
        this.new_password_special_char_valid
      );
    },
  },
  watch: {
    is_valid() {
      this.onChange(this.is_valid);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.checks {
  p {
    font-size: 13px;
    color: #acb6c1;
    margin: 0;
    margin-bottom: 6px;
    transition: color 0.3s;
    padding-left: 20px;
    position: relative;

    .yes,
    .no {
      transition: opacity 0.3s;
      opacity: 1;
      font-size: 14px;
      position: absolute;
      left: 0;
      top: 2px;
      color: #acb6c1;
    }

    .yes {
      opacity: 0;
      left: -9999px;
      color: $green;
    }
  }

  .valid {
    color: #26292f;

    .yes {
      opacity: 1;
      left: 0;
    }

    .no {
      opacity: 0;
      left: -9999px;
    }
  }
}
</style>
